import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const spotify: MusicService = {
  id: 'spotify',
  name: 'Spotify',
  shortName: 'Spotify',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: true,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    // `primary` = official Spotify brand green; `label` keeps the fym-common variant.
    primary: '#1DB954',
    label: '#1BD760',
    background: '#708775',
  },
  importerID: ImporterID.Spotify,
  musicAPIID: MusicAPIIntegrationID.Spotify,
  linkType: 'spotify',
  limits: {
    tracksPerPlaylist: 10000,
    addingTracks: 100,
  },
  assets: {
    logo: { light: 'spotify-light.svg', dark: 'spotify-dark.svg' },
    logoPadding: { light: 'spotify-light-padding.svg', dark: 'spotify-dark-padding.svg' },
    logoColor: { light: 'spotify-color-light.svg', dark: 'spotify-color-dark.svg' },
    logoColorPadding: {
      light: 'spotify-color-light-padding.svg',
      dark: 'spotify-color-dark-padding.svg',
    },
    logoOnBackground: 'spotify-dark.svg',
  },
  whatIsDescription: musicServiceMessages.spotifyWhatIs,
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: true,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: true,
    doesSupportAddingTracksToLibrary: true,
    doesSupportRemovingTracksFromLibrary: true,
    doesSupportFetchingLibraryAlbums: true,
    doesSupportFetchingAlbums: true,
    doesSupportFetchingAlbumTracks: true,
    doesSupportAddingAlbums: true,
    doesSupportRemovingAlbums: true,
    doesSupportFetchingLibraryArtists: true,
    doesSupportFetchingArtists: true,
    doesSupportAddingArtistsToLibrary: true,
    doesSupportRemovingArtistsFromLibrary: true,
    doesSupportSearchByISRC: true,
    doesReturnISRC: true,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: true,
    doesReturnUserCountry: true,
    maxLimit: 50,
  },
};
